// removed by extract-text-webpack-plugin
module.exports = {"name":"_16a2Q","dob":"_5ncru","tfn":"_1Kx5H","type":"_2P0Bm","amountType":"_2Slr-","amountAllocated":"_2orBn","header":"_1Ktpp","comment":"_3jPjC"};


//////////////////
// WEBPACK FOOTER
// ./src/views/Beneficiaries/columns.scss
// module id = 256
// module chunks = 0